const apiUrl = process.env.REACT_APP_API_URL || "/api";

const authProvider = {
  // called when the user attempts to log in
  login: async ({
    username,
    password,
  }: {
    username: string;
    password: string;
  }) => {
    //    const request = new Request("http://localhost:5000/api/auth/login", {
    const request = new Request(`${apiUrl}/auth/login`, {
      method: "POST",
      body: JSON.stringify({ email: username, password }),
      headers: new Headers({ "Content-Type": "application/json" }),
    });
    try {
      const response = await fetch(request);
      if (response.status < 200 || response.status >= 300) {
        throw new Error("Login failed");
      }
      const { token } = await response.json();
      localStorage.setItem("auth", token);
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    }
  },
  // called when the user clicks on the logout button
  logout: () => {
    localStorage.removeItem("auth");
    return Promise.resolve();
  },
  // called when the API returns an error
  checkError: ({ status }: { status: number }) => {
    if (status === 401 || status === 403) {
      localStorage.removeItem("auth");
      return Promise.reject();
    }
    return Promise.resolve();
  },
  // called when the user navigates to a new location, to check for authentication
  checkAuth: () => {
    const token = localStorage.getItem("auth");
    if (!token) return Promise.reject();
    return Promise.resolve();
  },
  // called to get user identity (optional)
  getIdentity: async () => {
    const token = localStorage.getItem("auth");
    if (!token) {
      return Promise.reject();
    }

    try {
      // const response = await fetch("http://localhost:5000/api/auth/me", {
      const response = await fetch(`${apiUrl}/auth/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 401) {
        localStorage.removeItem("auth");
        return Promise.reject();
      }

      const { user } = await response.json();
      return { id: user.id, fullName: user.email };
    } catch (error) {
      localStorage.removeItem("auth");
      return Promise.reject();
    }
  },
  // called to get user permissions (optional)
  getPermissions: () => Promise.resolve(),
};

export default authProvider;
